import React from 'react';

import LookupStatusBadge from '~components/LookupStatusBadge';
import { Row } from '~components/table-view-v3';

interface ComponentProps {
  row: Row;
}

// Thin wrapper over the shared LookupStatusBadge — the supplier-invoices and
// co-contributions tables both consume API rows whose `status` already conforms
// to the {tag, name, colour} lookup shape, so the wrapper just unpacks it.
const StatusBadge: React.FC<ComponentProps> = ({ row }) => {
  const { status } = row || {};
  if (!status) return null;
  return <LookupStatusBadge status={status} />;
};

export default StatusBadge;
